import { client } from '../client';
import { GroupSummary, PlanDecision } from './types/types';

export interface ApplyPreviewPayload {
  base_amount_cents: number;
  dependent_id?: number;
  pay_with_credits?: boolean;
}

export interface AddMemberPayload {
  user_id: number;
}

export type InviteLinkOut = {
  url: string;
  token: string;
  max_members: number;
  member_count: number;
  remaining_slots: number;
};

export type ResolveInviteOut = {
  ok: boolean;
  reason?: 'INVALID_LINK' | 'AT_CAPACITY';
  group_id?: number;
  type?: 'DUO' | 'FAMILY' | 'INDIVIDUAL';
  name?: string;
  remaining_slots?: number;
};

export type AcceptLinkStatus = 'JOINED' | 'HAS_PLAN' | 'AT_CAPACITY' | 'OWNER_CANNOT_JOIN' | 'INVALID_TOKEN';

export type AcceptLinkResponse = {
  status: AcceptLinkStatus;
  group_id: number;
};

export const getPlanGroup = async (groupId: number): Promise<GroupSummary> => {
  const { data } = await client.get<GroupSummary>(`/patients/plans/groups/${groupId}`);
  return data;
};

export const getMyPlanSummary = async (): Promise<GroupSummary | null> => {
  const { data } = await client.get<GroupSummary | null>('/patients/plans/groups/summary');
  return data;
};

export const leavePlanGroup = async (groupId: number): Promise<GroupSummary> => {
  const { data } = await client.post<GroupSummary>(`/patients/plans/groups/${groupId}/leave`, {});
  return data;
};

export const addPlanMember = async (groupId: number, payload: AddMemberPayload): Promise<GroupSummary> => {
  const { data } = await client.post<GroupSummary>(`/patients/plans/groups/${groupId}/members`, payload);
  return data;
};

export const removePlanMember = async (groupId: number, memberId: number): Promise<GroupSummary> => {
  const { data } = await client.delete<GroupSummary>(`/patients/plans/groups/${groupId}/members/${memberId}`);
  return data;
};

export const getShareLink = async (groupId: number): Promise<InviteLinkOut> => {
  const { data } = await client.get<InviteLinkOut>(`/patients/plans/groups/${groupId}/share-link`);
  return data;
};

export const resolveInvite = async (token: string): Promise<ResolveInviteOut> => {
  const { data } = await client.get<ResolveInviteOut>(`/auth/invites/resolve/${token}`);
  return data;
};

export const acceptInviteByToken = async (token: string): Promise<AcceptLinkResponse> => {
  const { data } = await client.post<AcceptLinkResponse>('/patients/plans/groups/invites/accept-link', { token });
  return data;
};

export const previewPlanDecision = async (payload: ApplyPreviewPayload): Promise<PlanDecision> => {
  const { data } = await client.post<PlanDecision>('/patients/plans/groups/preview', payload);
  return data;
};

export const applyPlanDecision = async (payload: ApplyPreviewPayload): Promise<PlanDecision> => {
  const { data } = await client.post<PlanDecision>('/patients/plans/groups/apply', payload);
  return data;
};
